<template>
  <div class="container pt-x2 pb-x2 mb-x4 nav-container">
    <div class="row">
      <div class="col d-flex justify-content-between align-items-center">
        <div class="clickable" @click="goHome()">
          <img class="nav-logo nav-logo-mobile" src="/images/logo@2x.png">
          <img class="nav-logo nav-logo-desktop" src="/images/logotype-flat@2x.png">
        </div>
        <div class="auth-group d-flex align-items-center">
          <router-link to="/login" class="zero-btn zero-btn-standard zero-btn-primary" v-if="!isLoggedIn">
            Login
          </router-link>
          <div class="nav-menu-button" :class="{'navopen' : navMenuToggle}" v-if="isLoggedIn" @click="navMenuToggle = !navMenuToggle">
            <span class="mr-x1 avatar-greeting">Hi {{ userData.name.split(" ")[0] }}</span>
            <i class="fas fa-chevron-down avatar-chevron mr-x1"></i>
            <div class="avatar-image md avatar-background" :style="{ backgroundImage: 'url(' + filePath + 'uploads/profiles/' + userData.userimage + ')' }">
              <span v-if="!userData.userimage">{{ userData.name[0] }}</span>
            </div>
            <div class="nav-menu" :class="{'navopen': navMenuToggle}">
              <router-link to="/profile" class="zero-btn zero-btn-standard zero-btn-tertiary mb-x1">
                Profile
              </router-link>
              <router-link to="/users" class="zero-btn zero-btn-standard zero-btn-tertiary mb-x1" v-if="userData.permissions[0] === '1'">
                User MGMT
              </router-link>
              <router-link to="/jobs/all" class="zero-btn zero-btn-standard zero-btn-tertiary mb-x1" v-if="userData.permissions[0] === '1'">
                Jobs MGMT
              </router-link>
              <button class="zero-btn zero-btn-standard zero-btn-tertiary mb-x1" @click="logout()">
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="click-away" @click="navMenuToggle = !navMenuToggle" v-if="navMenuToggle"></div>
  </div>
</template>

<!-- <div class="zero-btn zero-btn-standard zero-btn-primary mr-x4" @click="logout()" v-if="isLoggedIn">
  Logout
</div> -->

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

const axios = require('axios')

// endpoint switcher
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'ExampleComponent',
  props: {
    authRequired: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': '',
        'userimage': ''
      },
      userToken: '',
      navMenuToggle: false,
      filePath: apiChoice
    }
  },
  components: {
  },
  created () {
    // check login for all pages
    // moved to mounted due to test logout issue
    if (!this.$cookies.isKey('u')) {
      console.log('u cookie not found')
      if (this.authRequired) {
        this.$router.push({ path: '/login' })
      }
      this.$emit('loggedout')
      this.isLoggedIn = false
    } else {
      // we could check every page load with a check to getuser call
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
      // we'll assume logged in with extra check for authrequired
      this.isLoggedIn = true
      if (this.authRequired) {
        // lets only add the cost of this call for authrequired routes
        // technically exposes authrequired modules on otherwise public routes, but...
        this.checkUser()
      }
    }
  },
  mounted () {},
  computed: {},
  methods: {
    logout () {
      axios
        .get(apiChoice + 'auth/logout', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.$cookies.remove('j')
          this.$cookies.remove('w')
          this.$cookies.remove('t')
          this.$cookies.remove('u')
          this.$router.push({ path: '/login' })
          this.$emit('loggedout')
          this.isLoggedIn = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          // this.isLoading = false
        })
    },
    goHome () {
      this.$router.push({ path: '/' })
    },
    checkUser () {
      axios
        .get(apiChoice + 'auth/getuser', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          this.isLoggedIn = true
        })
        .catch(() => {
          console.log('check user failed')
          this.isLoggedIn = false
          this.$emit('loggedout')
          // temp commenting these out to check if cookies are still there
          this.$cookies.remove('j')
          this.$cookies.remove('w')
          this.$cookies.remove('t')
          this.$cookies.remove('u')
          if (this.authRequired) {
            this.$router.push({ path: '/login' })
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/variables.scss";
.nav-container{
  z-index: 900;
  position: relative;
}
.nav-menu-button{
  position: relative;
  font-size: 16px;
  height: 40px;
  border-radius: 20px;
  border: solid 1px $color-action;
  // background: #fff;
  cursor: pointer;
  right: 0px;
  display: flex;
  align-items: center;
  padding: 0px 4px 0px 12px;
  .avatar-greeting{
    display: none;
  }
  .avatar-chevron{
    display: block;
    color: $color-action;
  }
  &:hover{
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
  }
  &.navopen{
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
  }
}
.nav-menu{
  position: absolute;
  top: 48px;
  right: 0px;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
  border-radius: 20px;
  border: solid 1px #dee1e4;
  background: #fff;
  padding: 16px;
  width: 200px;
  max-width: 90vw;
  display: none;
  z-index: 100;
  &.navopen{
    display: block;
  }
}
.nav-logo {
  height: 40px;
  &.nav-logo-mobile {
    display: block;
  }
  &.nav-logo-desktop {
    display: none;
  }
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .nav-menu-button{
    .avatar-greeting{
      display: block;
      color: $color-action;
      font-weight: 600;
    }
    .avatar-chevron{
      display: none;
    }
  }
  .nav-logo {
    &.nav-logo-mobile {
      display: none;
    }
    &.nav-logo-desktop {
      display: block;
    }
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
